<template>
  <div>
    <!-- <router-view class="router-view" v-slot="{ Component }">
      <transition :name="transitionName">
        <component :is="Component" />
      </transition>
    </router-view> -->
    <!-- <template> -->
    <router-view class="router-view" />
    <!-- </template> -->
  </div>
</template>

<script>
import { onDeactivated, reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/user'
import { useAppStore } from '@/store/app'
import axios from 'axios'
import { setLocal, getLocal } from '@/common/js/utils'
import { WhitePathList } from '@/enum'

export default {
  setup() {
    const router = useRouter()
    const userStore = useUserStore()
    const userApp = useAppStore()
    const state = reactive({ transitionName: 'slide-left' })

    router.beforeEach(async (to, from, next) => {
      document.title = to.meta.title
      updateVersion()
      if (to.meta?.index > from.meta?.index) state.transitionName = 'slide-left' // 向左滑动
      else if (to.meta?.index < from.meta?.index) state.transitionName = 'slide-right' // 由次级到主级
      else state.transitionName = '' // 同级无过渡效果
      userApp.setPlatform()
      if (WhitePathList.includes(to.path)) next()
      else {
        if (to.query.projectId){
          userStore.setProjectId(to.query.projectId)
        }
        await userStore.urlTokenLogin(to.query.projectId)
        next()
      }
    })

    onDeactivated(() => {})

    return { ...toRefs(state) }
  }
}

function updateVersion() {
  let url = `/version.json?${new Date().getTime()}`
  axios.get(url).then(res => {
    let vueVersion = res.data.version + ' ' + res.data.latestTime
    let h5Version = getLocal('h5Version') || '0'
    if (vueVersion !== h5Version) {
      localStorage.clear()
      setLocal('h5Version', vueVersion)
      window.location.reload()
    }
  })
}
</script>

<style lang="less">
html,
body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #f8f8f8;
}

* {
  -webkit-overflow-scrolling: touch;
}

#app {
  height: 100%;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #222;
  background: #f8f8f8;
}

.router-view {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  height: 100%;
  will-change: transform;
  transition: all 500ms;
  position: absolute;
  backface-visibility: hidden;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.van-badge--fixed {
  z-index: 1000;
}
</style>
